export default {
    Hidden: 'hidden',
    Text: 'text',
    Select: 'select',
    UserSelect: 'user-select',
    ContactSelect: 'contact-select',
    DateRange: 'date-range',
    NumberRange: 'number-range'
};